import React, { PureComponent } from 'react'
import styled from 'styled-components'
import { Col, Container, Row } from 'reactstrap'
import { injectIntl } from 'react-intl'

import brandLogo from './images/brand-logo.png'
import studiocubowebLogo from './images/studiocuboweb.png'

import { FormattedMessage } from 'react-intl'

const FooterContainer = styled.div`
  align-items: center;
  background: #00a79d;
  bottom: 0;
  display: flex;
  color: #fff;
  font-size: 0.8rem;
  height: 4.5rem;
  position: fixed;
  width: 100%;
  z-index: 400;

  @media (max-width: 768px) {
    height: 7rem !important;
  }
`

const RowWrapper = styled(Row)`
  align-items: center;
`

const ColWrapper = styled(Col)`
  text-align: center;
`

const ColWrapperMedia = styled(ColWrapper)`
  font-size: 1.5rem;

  svg {
    margin-left: 0.4rem;
  }
`

const BrandLogoContainer = styled.img.attrs({
  src: brandLogo
})`
  max-width: 300px;
`

const StudioCuboWebLogoContainer = styled.img.attrs({
  src: studiocubowebLogo
})`
  max-width: 210px;
`

class Footer extends PureComponent {
  render () {
    return (
      <FooterContainer>
        <Container>
          <RowWrapper>
            <ColWrapper xs='12' md='4' className="p-">
              <b>IMAFLORA</b> - { this.props.intl.formatMessage({ id: 'footer.rights' }) } { new Date().getFullYear() }
            </ColWrapper>
            <ColWrapper xs='12' md='4' className='d-flex my-2 my-md-0'>
              <ColWrapperMedia>
                <BrandLogoContainer />
              </ColWrapperMedia>
            </ColWrapper>
            <ColWrapper xs='12' md='4'>
              <a href="https://studiocuboweb.com.br/" target="_blank">
                <StudioCuboWebLogoContainer />
              </a>
            </ColWrapper>
          </RowWrapper>
        </Container>
      </FooterContainer>
    )
  }
}

export default injectIntl(Footer)



// WEBPACK FOOTER //
// ./src/components/organisms/Footer/Footer.js